<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    class="icon-cross"
    width="12"
    height="12"
    :class="{'icon-cross_red': red, 'icon-cross_black': black}"
  >
    <path class="svg-colorized-el" fill-rule="evenodd" d="M7.426 6l4.279-4.278A1.008 1.008 0 1 0 10.278.295L6 4.574 1.721.295A1.008 1.008 0 1 0 .295 1.722L4.574 6 .295 10.278a1.008 1.008 0 0 0 1.426 1.427L6 7.426l4.278 4.279a1.008 1.008 0 1 0 1.427-1.427L7.426 6z" clip-rule="evenodd"/>
  </svg>
</template>

<script>
export default {
  props: {
    red: Boolean,
    black: Boolean,
  },
};
</script>

<style lang="scss" scoped>
  .icon-cross_red {
    use {
      fill: $red-color3;
    }
  }
  .icon-cross_black {
    use {
      fill: $black-color1;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/icons/IconCross.vue